<!-- @veltra/icons generated sha256:319c6022d6eb6d16 gen:8 source:src/svg/normal/form-radio.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormRadio' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="1.2" />
    <circle cx="8" cy="8" r="2.5" fill="currentColor" />
  </svg>
</template>
